<template>
  <Card
    class="library-card"
    @mouseover="handleCardOver(card.id)"
    @mouseleave="handleCardLeave"
  >
    <div
      v-if="selectedCardId === card.id"
      class="card-background"
    >
      <div class="card-action-wrapper">
        <button
          type="button"
          @click="openCardPreview"
          class="card-action-button"
        >
          <div class="icon-label">
            <img src="/static/images/ic-eye.svg" alt="icon" />
            {{ $t('common.preview') }}
          </div>
        </button>
        <button
          type="button"
          @click="goToCardDetails"
          class="card-action-button"
        >
          <div class="icon-label">
            <img src="/static/images/ic-zoom-in.svg" alt="icon" />
            {{ $t('common.detail_view') }}
          </div>
        </button>
      </div>
    </div>
    <div
      class="card-cover-img-thumb clickable"
      :style="styleBindings"
    >
      <div v-if="false" class="card-action">
        <div class="card-action-btn">
          <IconDropdown :dropup="false">
            <b-dropdown-item class="dropdown-item" @click="openCardPreview">{{ $t('common.preview') }}</b-dropdown-item>
          </IconDropdown>
        </div>
      </div>
    </div>
    <div class="card-block clickable">
      <div class="row">
        <div class="col-12 card-info-section">
          <div class="card-body">
            <h4 class="card-title" :class="card.title.length > 20 && 'long-title'" v-bind:title="card.title">
              {{ card.title }}
            </h4>
            <div class="card-subtitle typography--caption">
              {{ getGradeLabel(card) }} ∙
              {{ getSubjectLabel(card) }}
              <span v-if="card.chapter_name">
                ∙ {{ card.chapter_name }}
              </span>
              <span v-else-if="card.core_concept_id">
                ∙ {{ getCoreConceptLabel(card.core_concept) }}
              </span>
            </div>
          </div>
          <div class="divider"></div>
          <div class="card-bottom-desc">
            <div>
              <small class="typography--caption typography--color-secondary">
                <span v-if="(card.page_count - card.quiz_count) > 0">
                  {{ $t('common.card.non_quiz') }} {{ $t('common.card.count', { cnt: card.page_count - card.quiz_count }) }}
                </span>
                <span v-if="(card.page_count - card.quiz_count) > 0 && card.quiz_count > 0">∙</span>
                <span v-if="card.quiz_count > 0">
                  {{ $t('common.card.quiz') }} {{ $t('common.card.count', { cnt: card.quiz_count }) }}
                </span>
                <span v-else style="color: transparent">_</span>
              </small>
            </div>
            <div>
              <small class="typography--caption typography--color-secondary">
                <strong>{{ card.author_name }}</strong>
                <span v-if="card.assigned_count">| {{ $t('common.card.share_count', { cnt: card.assigned_count }) }}</span>
              </small>
            </div>
            <div v-if="!card.publisher_id">
              <small class="typography--caption typography--color-secondary">
                {{ $t('common.card.updated_at') }}: {{ card.updated_at | datetime }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isEmpty, isNil } from 'lodash';
  import labels from '@/mixins/labels';

  export default {
    name: 'library-card',

    data() {
      return {
        selectedCardId: null,
      };
    },

    props: [
      'card',
    ],

    mixins: [
      labels,
    ],

    computed: {
      ...mapGetters([
        'customCards',
        'subjectMap',
        'gradeMap',
      ]),

      isPublisherCard() {
        if (this.card) {
          return (!isNil(this.card.publisher_id) &&
            !isNil(this.card.author_id) &&
            isNil(this.card.store_card_id));
        }

        return false;
      },

      styleBindings() {
        if (this.card) {
          return {
            'background-image': `url('${this.card.cover_image}')`,
          };
        }

        return {};
      },
    },

    methods: {
      ...mapActions([
        'setSelectedPreviewPageIndex',
        'fetchPublisherCardPages',
        'setSelectedPreviewCard',
        'fetchCustomCardPages',
      ]),

      goToCardDetails() {
        if (this.isPublisherCard) {
          return this.$router.push(`/library/publisher-cards/${this.card.id || this.card.copy_id}`);
        }

        return this.$router.push(`${this.$route.path}/${this.card.id}`);
      },

      setPreviewCard() {
        return this.setSelectedPreviewCard(this.card)
          .then(() => (
            this.setSelectedPreviewPageIndex(0)
          ))
          .then(() => {
            this.$root.$emit('show::modal', 'card-preview-modal');
          });
      },

      openCardPreview() {
        if (this.isPublisherCard) {
          if (!isEmpty(this.card.pages)) {
            return this.setPreviewCard();
          }

          return this.fetchPublisherCardPages(this.card.id)
            .then(() => (
              this.setPreviewCard()
            ))
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }

        return this.fetchCustomCardPages(this.card.id)
          .then(() => (
            this.setPreviewCard()
          ))
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      },

      handleCardOver(cardId) {
        this.selectedCardId = cardId;
      },

      handleCardLeave() {
        this.selectedCardId = null;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/library/components/LibraryCard.vue